import { HolidayForm } from '../types/holiday.types';

export const DOW_LABELS = ['월', '화', '수', '목', '금', '토', '일'] as const;

export const DEFAULT_HOLIDAY_FORM: HolidayForm = {
    seqNo: null,
    holidayDate: '',
    holidayName: '',
    targetDow: '7',
};
